import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Modal,
  Button,
  Spinner,
  Alert,
  Card,
  Form,
  ListGroup,
} from "react-bootstrap";

const OtrosSi = ({ numContrato }) => {
  const [data, setData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://contratosback-dev.azurewebsites.net/api/v1/ObtenerOtroSi/${numContrato}`
        );
        console.log("Respuesta de la API:", response.data);
        if (response.data.length > 0) {
          setData(response.data[0]);
          console.log("Data guardada:", response.data[0]);
        } else {
          setData(null);
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
        setError("No se pudo obtener la información.");
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [numContrato]);

  if (loading) {
    return (
      <div className="text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden"></span>
        </Spinner>
        <p className="mt-2">Cargando datos...</p>
      </div>
    );
  }

  if (!data) {
    return (
      <p className="text-muted" style={{ fontSize: "0.8rem" }}>
        Sin información en el sistema
      </p>
    );
  }

  return (
    <div>
      <Button variant="primary" size="sm" onClick={() => setShowModal(true)}>
        Ver Información
      </Button>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Información del Contrato: {numContrato}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error ? (
            <Alert variant="danger">{error}</Alert>
          ) : (
            <>
              {/* Comentarios */}
              <Card className="mb-3">
                <Card.Header className="bg-primary text-white">
                  Comentarios
                </Card.Header>

                <Card.Body>
                  {data.comentarios?.length > 0 ? (
                    <ListGroup>
                      {data.comentarios.map((comentario) => (
                        <ListGroup.Item key={comentario.id}>
                          <strong>Usuario:</strong> {comentario.nombre}
                          <Form.Control
                            as="textarea"
                            value={comentario.comentarios}
                            disabled
                          />
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  ) : (
                    <p>No hay comentarios disponibles.</p>
                  )}
                </Card.Body>
              </Card>

              {/* Archivos */}
              <Card className="mb-3">
                <Card.Header className="bg-info text-white">
                  Archivos
                </Card.Header>
                <Card.Body>
                  {data.archivos &&
                  Array.isArray(data.archivos) &&
                  data.archivos.length > 0 ? (
                    <ListGroup>
                      {data.archivos.map((archivo) => (
                        <ListGroup.Item key={archivo.id}>
                          <strong>Archivo:</strong> {archivo.nombre}{" "}
                          <a
                            href={archivo.archivo}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Descargar
                          </a>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  ) : (
                    <p>No hay archivos disponibles.</p>
                  )}
                </Card.Body>
              </Card>

              {/* Contrato */}
              <Card>
                <Card.Header className="bg-primary text-white">
                  Contrato
                </Card.Header>
                <Card.Body>
                  {data.contrato ? (
                    <div
                      dangerouslySetInnerHTML={{ __html: data.contrato }}
                      style={{
                        background: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "5px",
                      }}
                    />
                  ) : (
                    <p>No hay información del contrato disponible.</p>
                  )}
                </Card.Body>
              </Card>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OtrosSi;
